import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const Label = styled.p<{ color?: string }>`
  color: ${({ color }) => color || '#7f7f7f'};
  margin-bottom: 0px;
  font-weight: 300;
  font-size: 15px;
`;

export const Button = styled(ButtonAntD)`
  height: 42px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;
  margin-left: 16px;
  margin-top: 2px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
    color: #fff;
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }

  &:disabled {
    background-color: ${COLORS.hover};
    cursor: not-allowed;
    border: none;
    pointer-events: none;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MeterDeviceResponseContainer = styled.div<{
  color: string;
  borderColor: string;
  isLoading?: boolean;
}>`
  border-radius: 8px;
  background-color: ${({ color }) => color};
  border: 1px solid;
  border-color: ${({ borderColor }) => borderColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ isLoading }) => (isLoading ? 'center' : 'flex-start')};
  padding: 10px 12px;
  margin-bottom: 5px;
`;

export const StyledDot = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 12px;
  background-color: ${({ color }) => color};
  margin-right: 8px;
`;

export const TimeStampContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;
